import { userRoles, userStatus } from "../constants/user";

interface Log {
  updatedBy: any;
  _id: string;
  fromStatus?: string;
  toStatus: string;
  time: string;
  remark?: string;
}

const countTotalEnhanceApprovalFields = (logs: Log[], fieldName: keyof typeof userStatus): number => {
  const baseStatusPrefix = userStatus[fieldName].split("_(")[0];
  return logs.reduce((count, log) => {
    if (log.toStatus && log.toStatus.startsWith(baseStatusPrefix)) {
      count++;
    }
    return count;
  }, 0);
};

export const getNextStatus = (patientData: any, role: string, isStablePatient: boolean) => {
  const prevStatus = patientData.status.split('_(')[0] as string;

  const enhanceApprovalRequestCount = countTotalEnhanceApprovalFields(
    patientData.logs as Log[],
    "ENHANCE_APPROVAL_REQUEST"
  )

  let nextStatus: string[] = [];

  switch (true) {
    case (prevStatus === userStatus.DRAFTED || prevStatus === userStatus.QUERY_RAISED) &&
      [userRoles.SUPER_ADMIN, userRoles.SURGEON].includes(role):
      nextStatus = [userStatus.SUBMITTED];
      break;
    case prevStatus === userStatus.SUBMITTED &&
      [userRoles.SUPER_ADMIN, userRoles.D_C].includes(role):
      nextStatus = [userStatus.QUERY_RAISED, userStatus.APPROVED, userStatus.REJECTED];
      break;
    case prevStatus === userStatus.APPROVED &&
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role):
      nextStatus = [
        userStatus.FOLLOW_UP_ONE,
        userStatus.FOLLOW_UP_THREE,
        userStatus.FOLLOW_UP_SEVEN,
        userStatus.FOLLOW_UP_FIFTEEN,
        userStatus.ADMITTED,
        userStatus.NOT_ADMITTED,
        userStatus.EXPIRED
        // userStatus.ESTIMATE_APPROVAL
      ];
      if(isStablePatient === true) {
        nextStatus.push(userStatus.ESTIMATE_APPROVAL_REQUEST);
      }
      break;
    case prevStatus === userStatus.FOLLOW_UP_ONE &&
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role):
      nextStatus = [
        userStatus.FOLLOW_UP_THREE,
        userStatus.FOLLOW_UP_SEVEN,
        userStatus.FOLLOW_UP_FIFTEEN,
        userStatus.ADMITTED, 
        userStatus.NOT_ADMITTED,
        userStatus.EXPIRED
      ];
      if(isStablePatient === true) {
        nextStatus.push(userStatus.ESTIMATE_APPROVAL_REQUEST);
      }
      break;
    case prevStatus === userStatus.FOLLOW_UP_THREE &&
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role):
      nextStatus = [
        userStatus.FOLLOW_UP_SEVEN,
        userStatus.FOLLOW_UP_FIFTEEN,
        userStatus.ADMITTED, 
        userStatus.NOT_ADMITTED,
        userStatus.EXPIRED
        // userStatus.ESTIMATE_APPROVAL_REQUEST
      ];
      if(isStablePatient === true) {
        nextStatus.push(userStatus.ESTIMATE_APPROVAL_REQUEST);
      }
      break;
    case prevStatus === userStatus.FOLLOW_UP_SEVEN &&
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role):
      nextStatus = [
        userStatus.FOLLOW_UP_FIFTEEN,
        userStatus.ADMITTED, 
        userStatus.NOT_ADMITTED, 
        userStatus.EXPIRED
        // userStatus.ESTIMATE_APPROVAL
      ];
      if(isStablePatient === true) {
        nextStatus.push(userStatus.ESTIMATE_APPROVAL_REQUEST);
      }
      break;
    case prevStatus === userStatus.FOLLOW_UP_FIFTEEN &&
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role):
      nextStatus = [
        userStatus.ADMITTED, 
        userStatus.NOT_ADMITTED,
        userStatus.EXPIRED
        // userStatus.ESTIMATE_APPROVAL
      ];
      if(isStablePatient === true) {
        nextStatus.push(userStatus.ESTIMATE_APPROVAL_REQUEST);
      }
      break;
    case prevStatus === userStatus.ESTIMATE_APPROVAL_REQUEST &&
      [userRoles.SUPER_ADMIN, userRoles.D_C].includes(role):
      nextStatus = [
        userStatus.ESTIMATE_APPROVED, 
        userStatus.ESTIMATE_QUERY_RAISED,
      ];
      break;
    case prevStatus === userStatus.ESTIMATE_APPROVED &&
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role):

      const usedStatuses = patientData?.logs?.map((log : Log) => log.toStatus);
      nextStatus = [
        userStatus.FOLLOW_UP_ONE,
        userStatus.FOLLOW_UP_THREE,
        userStatus.FOLLOW_UP_SEVEN,
        userStatus.FOLLOW_UP_FIFTEEN,
        userStatus.ADMITTED,
        userStatus.NOT_ADMITTED,
        userStatus.EXPIRED
        // userStatus.ESTIMATE_APPROVAL_PENDING
      ].filter(status => !usedStatuses.includes(status));

      break;
    case prevStatus === userStatus.ESTIMATE_QUERY_RAISED &&
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role):
      nextStatus = [
        userStatus.ESTIMATE_APPROVAL_REQUEST, 
        userStatus.EXPIRED
        // userStatus.ESTIMATE_QUERY_RAISED,
      ];
      break;
    case prevStatus === userStatus.ADMITTED &&
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role):
      nextStatus = [
        userStatus.EXPIRED,
        userStatus.DISCHARGED,
        userStatus.LAMA,
        userStatus.ENHANCE_APPROVAL_REQUEST + `_(${enhanceApprovalRequestCount + 1})`,
      ];
      break;
    case prevStatus === userStatus.ENHANCE_APPROVAL_REQUEST &&
      [userRoles.SUPER_ADMIN, userRoles.D_C].includes(role):
      nextStatus = [
        userStatus.ENHANCE_APPROVED + `_(${enhanceApprovalRequestCount})`,
        userStatus.QUERY_RAISED_ON_ENHANCE + `_(${enhanceApprovalRequestCount})`,
      ];
      break;
    case (prevStatus === userStatus.ENHANCE_APPROVED ) &&
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role):
      nextStatus = [
        userStatus.EXPIRED,
        userStatus.DISCHARGED,
        userStatus.LAMA,
        userStatus.ENHANCE_APPROVAL_REQUEST + `_(${enhanceApprovalRequestCount + 1})`,
      ];
      break;
    case (prevStatus === userStatus.QUERY_RAISED_ON_ENHANCE ) &&
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role):
      nextStatus = [
        userStatus.EXPIRED,
        userStatus.ENHANCE_APPROVAL_REQUEST + `_(${enhanceApprovalRequestCount + 1})`,
      ];
      break;
    case (prevStatus === userStatus.DISCHARGED || prevStatus === userStatus.LAMA || prevStatus === userStatus.EXPIRED) &&
      [userRoles.SUPER_ADMIN, userRoles.STAFF].includes(role):
      nextStatus = [
        userStatus.CLOSED
      ];
      break;

    default:
      nextStatus = [];
      break;
  }

  return nextStatus;
};
